import { Component, OnInit } from '@angular/core';
import { MatButtonToggleChange, MatDialog, MatTabChangeEvent } from '@angular/material';
import { Employee } from '@akiba/models_bimbo';
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
import { saveAs } from 'file-saver';
import { UiService } from 'projects/bimbo/src/app/services/ui.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import * as moment from 'moment';
import { take } from 'rxjs/operators';
import { Helpers } from './../../../../models/helpers';

@Component({
  selector: 'app-ss-registration',
  templateUrl: './ss-registration.component.html',
  styleUrls: ['./ss-registration.component.scss']
})
export class SsRegistrationComponent implements OnInit {
  selectedIndex = 0;
  // update file
  displayedColumns: string[] = ['row', 'employeeNumber', 'investmentType', 'contractNumber', 'message'];
  multipleFiles: boolean = false;
  fileSelected = Array<File>();
  fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
  employeeFile: any;
  format = 'DD-MMM-YYYY';
  dateNow: Date = new Date();
  selectedFileResults: Array<any> = new Array<any>();
  employeeFileHasErrors = false;
  messageError: string = '';
  plantilla = '../../../../../assets/img/plantilla.png';

  collectionByHeader: Array<any> = [
    { title: 'colaborador', property: 'employeeNumber' },
    { title: 'nombreColaborador', property: 'nameEmployee' },
    { title: 'compania', property: 'companyName' },
    { title: 'fecha', property: 'dateRegister' },
    { title: 'numContrato', property: 'contractNumber' },
    { title: 'tipoContrato', property: 'investmentType' }
  ];
  textAction = "Los colaboradores se agregaran a lista ya cargada anteriormente.";
  saveAction = "add";

  constructor(private ui: UiService, private dataSource: DataSourceService, public dialog: MatDialog, private UI: UiService) {
  }

  ngOnInit() {
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  typeUpload(event: string) {
    this.saveAction = event;
    if (event === "add") {
      this.textAction = "Los colaboradores se agregaran a lista ya cargada anteriormente.";
    } else {
      this.textAction = "La lista de colaboradores cargada con anterioridad se eliminara completamente, sustituyendo los colaboradores con la nueva lista.";
    }



  }

  onFileChange(event: any): void {
    this.employeeFile = event.target.files[0];

    const reader = new FileReader();
    reader.onload = async (e) => {

      this.ui.showSpinner();

      const workBook = await XlsxPopulate.fromDataAsync(reader.result);
      const rows = workBook.sheet(0).usedRange() ? workBook.sheet(0).usedRange().value() : [];
      const employees = new Array<any>();
      let index = 0;
      for (const row of rows) {

        const employee: any = {};

        if (row[0] !== undefined && index > 0) {

          employee.employeeNumber = row[0] ? String(row[0]).trim() : '';
          employee.investmentType = row[1] ? String(row[1]).trim().toLowerCase() : '';
          employee.contractNumber = row[2] ? String(row[2]).trim().toLowerCase() : '';

          let result = { employee: employee, index: index };
          employees.push(result);
        }
        index++;
      }

      this.selectedFileResults = await this.verifyEmployees(employees);

      this.employeeFileHasErrors = this.selectedFileResults.some(fr => fr.message.length) === false;
      this.selectedFileResults.map(e => this.messageError = e.message);

      this.ui.stopSpinner();

    };

    reader.readAsArrayBuffer(this.employeeFile);

  }



  async createTemplateFile(): Promise<void> {

    const xlsx = await XlsxPopulate.fromBlankAsync();

    const sheetData = ['Numero Colaborador', 'Tipo Accion', 'Num. Contrato'];
    const sheetEntries = sheetData.entries();

    for (const [i, v] of sheetEntries) {
      const cell = xlsx.sheet(0).row(1).cell(i + 1);
      cell.value(v);
      cell.style('shrinkToFit', false);
      cell.style('bold', true);
      cell.style('fill', '1565c0');
      cell.style('fontColor', 'ffffff');
      const len = Math.max(20, v.length);
      xlsx.sheet(0).column(i + 1).width(len);
    }
    xlsx.sheet(0).name('Listado');

    xlsx.outputAsync('blob').then((out: any) => {
      saveAs(out, 'akiba-AHOA.xlsx');
    }).catch((error: any) => {
      console.log('error', error);
    });

  }

  async verifyEmployees(employeesMeta: Array<any>): Promise<Array<any>> {

    console.log(employeesMeta);

    const results = Array<any>();

    if (employeesMeta && employeesMeta.length < 1) {
      return [{ message: ['El archivo no contiene información'], success: false, employee: '', index: -1 }];
    }

    for (const employees of employeesMeta) {

      const result = await this.verifyEmployee(employees);
      results.push(result);

    }

    return results;

  }

  async verifyEmployee(employeeMeta: any): Promise<any> {
    employeeMeta.employee.active = true;
    employeeMeta.employee.registrationDate = this.dateNow;

    const errors = new Array<string>();

    if (!employeeMeta.employee.employeeNumber) {
      errors.push('El número de empleado es requerido.');
    }

    if (!employeeMeta.employee.investmentType || employeeMeta.employee.investmentType.length < 1) {
      errors.push('El tipo de acción es requerido');
    }



    /* 
        if (!employeeMeta.employee.contractNumber) {
      errors.push('Especificar si tiene contrato o no');
    }
    
      if (!employeeMeta.payments) {
        errors.push('El número de pagos es requerido');
      }*/

    return { message: errors, success: errors.length === 0, employee: employeeMeta.employee, index: employeeMeta.index };

  }


  async saveEmployees() {

    let messageSave = "";
    if (this.saveAction === "add") {
      messageSave = "¿Deseas agregar el registro de los colaboradores en la Caja de Ahorro por Acciones?"

    } else {
      messageSave = "¿Deseas sustituir el registro de los colaboradores en la Caja de Ahorro por Acciones?";
    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: messageSave,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        this.UI.showSpinner();

        this.dataSource.addShareSavings(this.saveAction, this.selectedFileResults).then((result) => {

            this.UI.stopSpinner();
            this.resetEmployees();
            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'Los colaboradores se ha guardado correctamente.',
                close: 'Aceptar'
              }
            });

        }).catch(error => {
          console.log('mesage', error.message);
        });

      }

    });

  }

  resetEmployees() {
    this.selectedFileResults = new Array<any>();
    this.employeeFile = undefined;
    this.saveAction = "add";
    this.textAction = "Los colaboradores se agregaran a lista ya cargada anteriormente.";

  }

  async descargar() {
    const type = 'shareSavingsUsers';
    this.ui.showSpinner();
    const xlsx = await XlsxPopulate.fromBlankAsync();

    this.buildReportHeader(xlsx, type, null, this.collectionByHeader);
    let row = 5;

    this.dataSource.callbackWithArray = async (batchResults: Array<any>) => {

      for (const doc of batchResults) {

        if (!doc) {
          continue;
        }

        const dateCast = moment(doc.registrationDate.toDate()).locale('es').format(this.format);
        const emp: any = await this.dataSource.loadEmployee(doc.employeeNumber).pipe(take(1)).toPromise();
        const employee = new Employee(emp);

        doc.dateRegister = dateCast != 'Invalid date' ? dateCast : 'Fecha-invalida';
        doc.nameEmployee = employee.firstName + ' '+ employee.firstLastName + ' ' + employee.secondLastName;
        doc.companyName = employee.workInformation.companyRef.companyName; 
        this.buildReport(xlsx, this.collectionByHeader, doc, row);
        row++;

      }

      return true;

    };


    await this.dataSource.loadShareSavings(type, 5000, 15000).catch(error => console.log(error));


    xlsx.outputAsync('blob').then(out => {
      this.ui.stopSpinner();
      saveAs(out, type + '-akiba.xlsx');
    }).catch((error: any) => {
      this.ui.stopSpinner();
      console.log('error', error);
    });


  }

  // funciones auxiliares para la creación y descarga del excel 

  buildReportHeader(xlsxRef: any, type: string, subTypes: Array<string> | null, headers: Array<any>) {


    let title = type;
    if (subTypes) {
      title = subTypes.join(' / ');
    }

    xlsxRef.sheet(0).row(2).cell(1).value(title);

    const headerRef = xlsxRef.sheet(0).row(4);
    let headerCellIndex = 1;
    for (const header of headers) {
      const cell = headerRef.cell(headerCellIndex);
      this.buildCell(cell, header.title);
      headerCellIndex++;
    }

  }

  buildReport(xlsxRef: any, headers: Array<any>, data: any, row: number) {

    const rowRef = xlsxRef.sheet(0).row(row);

    let cellIndex = 1;
    for (const header of headers) {
      const cell = rowRef.cell(cellIndex);
      this.buildCell(cell, header.property, data);
      cellIndex++;
    }

  }


  buildCell(cell: XlsxPopulate.Cell, property: string, data: any = null) {

    if (data) {
      const properties = property.split('.');
      const value = this.searchPropertyValue(properties, data);

      if (!Helpers.isObject(value)) {

        cell.value(value);

      } else {

        try {

          if (Helpers.isDate(value)) {
            const aDate = moment(value).locale('es').format(this.format);
            cell.value(aDate);
          } else if (typeof value.toDate === 'function') {

            const time = moment.unix(value.seconds).utc(true);
            const year = time.year();
            const month = time.month();
            const day = time.date();
            const newD = new Date(year, month, day);
            const aDate = moment(newD).locale('es').format(this.format);
            cell.value(aDate);

          } else {
            cell.value('-');
          }

        } catch (error) {
          cell.value('-');
        }

      }

    } else {
      cell.value(property);
    }

  }

  searchPropertyValue(propertyNames: Array<string>, object: any): any {

    if (propertyNames.length) {

      const pName = propertyNames.splice(0, 1)[0].trim();

      if (object.hasOwnProperty(pName)) {
        const childObject = object[pName];
        return this.searchPropertyValue(propertyNames, childObject);
      }

    }

    return object;

  }

}
